import React, { ReactElement, useEffect, useState, useRef } from 'react'
import { getHotQuestion } from '@/services/rag'
import { useSelector } from 'react-redux'
import { IAppState } from '@/store/reducers'
import { Image, Space, Avatar, Button } from 'antd'
import { marked, } from 'marked'
import { ThunderboltOutlined } from '@ant-design/icons'
import DefaultHeadImg from '@/assets/images/defaultHeadImg.jpg'

const renderer = new marked.Renderer()
const { ...defaults } = marked.getDefaults()

const DefaultCon = (props: {
    // eslint-disable-next-line no-unused-vars
    sendHotQuestion: (item: any) => void
}): ReactElement => {
    const { sendHotQuestion } = props

    const userInfo = useSelector((state: IAppState) => state.auth.userInfo)
    const [hotList, setHotList] = useState<any[]>([])
    const $tokens = useRef(
        marked.lexer(`
### 操作指南
1. **输入产品需求，自动生成技术方案** 
- 在输入框中输入您的产品需求，AI将自动分析并推荐实现需求的技术要点，无需手动查找或推敲。

2. **通过对话确认需求与技术方案的匹配（可选）** 
- 如果需要进一步确认技术方案是否符合需求，您可以与AI展开多轮对话，逐步优化方案，确保每个技术点都能准确满足您的预期。

3. **一键生成提案总结** 
- 在AI分析结果页面的右下角点击“提案对接”按钮，AI会根据技术要点自动关联ITMT系统提案，并为您生成完整的提案总结，轻松完成提案文档。
        `)
    )

    const getHotQuestionFn = () => {
        getHotQuestion().then(resData => {
            setHotList(resData.slice(0, 4))
        })
    }
    const onClickHotBtn = (e: any) => {
        sendHotQuestion(e.desc)
    }

    useEffect(() => {
        getHotQuestionFn()
        return () => {
            // 取消请求
        }
    }, [])

    return <div>
        <Space style={{ fontSize: 30 }}>
            <Avatar size={50} icon={
                <Image src={userInfo?.avatar || DefaultHeadImg} width={50} preview={false}
                />
            }/>
            Hello, <b>{userInfo?.nickName}</b>
        </Space>
        <p style={{ marginLeft: 60, marginBottom: 10, fontSize: 30, color: '#ccc' }}>How can I help you today?</p>
        {$tokens.current.map((token: any, index: number) => {
            const newDefault = {
                ...defaults
            }
            const htmlStr = marked.parse(token.raw, {
                ...newDefault,
                gfm: true,
                breaks: true,
                renderer
            })
            return <div key={index} className='token_box'
                dangerouslySetInnerHTML={{
                    __html: htmlStr as string
                }}
            >
            </div>
        })}
        <h3 style={{ margin: '20px 0' }}><ThunderboltOutlined style={{ color: '#f19a09' }} /> 热点问题</h3>
        <Space size={20} className='hot_list'>
            {hotList.map(item => <Button key={item.problemId}
                className='hot_button'
                onClick={() => onClickHotBtn(item)}
            >
                <h3 style={{ width: '100%', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2 }}>{item.desc}</h3>
                <p className='hot_number'><ThunderboltOutlined style={{ fontSize: 12, color: '#f19a09' }} />{item.hot}</p>
            </Button>)}
        </Space>
    </div>
}

export default DefaultCon